module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/smoke.6786efb1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/smoke.png
// module id = 3326
// module chunks = 11